import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaMenu24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMegaMenu24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 5.5H5A1.5 1.5 0 0 0 3.5 7v10A1.5 1.5 0 0 0 5 18.5h14a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 19 5.5M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm.25 4.75A.75.75 0 0 1 6 8h4a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75M6 11a.75.75 0 0 0 0 1.5h2A.75.75 0 0 0 8 11zm-.75 3.75A.75.75 0 0 1 6 14h2a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75M14 11a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zm-.75 3.75A.75.75 0 0 1 14 14h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M14 8a.75.75 0 0 0 0 1.5h4A.75.75 0 0 0 18 8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaMenu24);
